import declare from "dojo/_base/declare";
import Renderer from "csi/heading/Renderer";
import html from "csi/html";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ActionData from "csi/heading/ActionData";
import { TableWidget } from "csi/table/Widget";
import { getNumGroupingLevels } from "csi/middleware/customView/customViewDataManagementService";

const LevelRenderer = declare(Renderer, {
	/**
	 * @override
	 * Render Level number in case of multi-level table views. 
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement, actionData: ActionData) {
		const { queryResult, view } = ctx;
		const tableView = view as TableWidget;
		const count = getNumGroupingLevels(tableView.groupSettings);
		const nLevel = queryResult.hl + 1 - count;
		html.text(refNode, String(nLevel));
		return true;
	},
});

export = LevelRenderer;